const findInTree = <T extends { children: T[] }>(
    node: T,
    fn: (node: T) => boolean
): T | undefined => {
    if (fn(node)) {
        return node;
    }

    return findInTreeNodes(node.children, fn);
};

const findInTreeNodes = <T extends { children: T[] }>(
    nodes: T[],
    fn: (node: T) => boolean
): T | undefined => {
    for (const node of nodes) {
        const result = findInTree(node, fn);
        if (result) {
            return result;
        }
    }
    return undefined;
};

export default findInTreeNodes;
